// extracted by mini-css-extract-plugin
export default {"statPill":"dU9hiGAaYbX8DtI0X8Kf"};